import { Controller } from "@hotwired/stimulus"

// W1.7 graveyard triage keyboard: 1-7 submit the matching reason button,
// ArrowRight skips, Z undoes. Buttons are the source of truth (server-side
// forms); keys just click them, so there is no divergent client state.
export default class extends Controller {
  static targets = ["reason", "skip", "undo"]

  connect() {
    this.handler = (e) => this.keydown(e)
    document.addEventListener("keydown", this.handler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handler)
  }

  keydown(e) {
    if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") return
    const n = parseInt(e.key, 10)
    if (n >= 1 && n <= this.reasonTargets.length) {
      e.preventDefault()
      this.reasonTargets[n - 1].requestSubmit()
    } else if (e.key === "ArrowRight" && this.hasSkipTarget) {
      e.preventDefault()
      this.skipTarget.requestSubmit()
    } else if ((e.key === "z" || e.key === "Z") && this.hasUndoTarget) {
      e.preventDefault()
      this.undoTarget.requestSubmit()
    }
  }
}
